import './bootstrap';
import sort from '@alpinejs/sort'
import AlpineSwiper from 'alpine-js-swiper';
import './custom';

Alpine.plugin(sort);
Alpine.plugin(AlpineSwiper);